module.exports = __webpack_public_path__ + "static/media/20a.5ebc39ab.jpg";